import React, { Component } from 'react'
import "./createstudy.css"
import {
  Container,
  Form,
  Button,
  NavLink,
  Spinner
} from 'reactstrap';
import Game from "../../../src/components/Picture/ayutthaya.jpg";
import Lightbox from "react-image-lightbox";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDice,
  faGamepad,
  faCloud,
  faLeaf,
  faShippingFast,
  faCheckSquare,
  faUsers,
  faUserTie,
  faCrown,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faDice,
  faGamepad,
  faCloud,
  faLeaf,
  faShippingFast,
  faCheckSquare,
  faUsers,
  faUserTie,
  faCrown
);

class CreateStudy7 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }
  render() {
    const { isOpen } = this.state;
    return (
      
      <div>
        <Container className="comming">
        <Form className="boxstudy7">
        <h5 className="textstudy">เรื่องพัฒนาการและภูมิปัญญาไทยทางด้านเศรษฐกิจในสมัยกรุงสุโขทัย</h5><br></br>

        <Form className="b1"><h5 className="textS">ชนชั้นทางสังคมในสมัยสุโขทัย</h5>
        <h5 className="dd"><Spinner type="grow" color="warning" />สังคมสุโขทัยประกอบด้วยชนชั้นต่างๆ ดังต่อไปนี้</h5>
        <h5 className="dd"><Spinner type="grow" color="warning" />๑. ภูมิปัญญาในการดำรงชีวิต</h5>
        <h5 className="dd"><Spinner color="primary" />๑. ชนชั้นผู้ปกครอง ได้แก่</h5>
        <h5 className="dd"><Spinner type="grow" color="secondary" />(๑) พระมหากษัตริย์จะมีหน้าที่ปกครองอาณาจักรให้มีความมั่นคงเป็นปึกแผ่น รวมไปถึงการดูแลราษฎรให้ทำมาหากินและดำรงชีวิติอย่างเป็นปกติสุข</h5>
        <h5 className="dd"><Spinner type="grow" color="secondary" />(๒) เจ้านายหรือขุนนาง เป็นกลุ่มพระราชวงศ์ และเข้าราชการที่มีหน้าที่ช่วยเหลือพระมหากษัตริย์ในการปกครองบ้านเมือง</h5>
        <h5 className="dd"><Spinner color="primary" />๒. ชนชั้นผู้ถูกปกครอง ได้แก่</h5>
        <h5 className="dd"><Spinner type="grow" color="secondary" />(๑) ไพร่ ประชาชน เป็นชนชั้นกลุ่มใหญ่ของสังคม ในยามที่บ้านเมืองสงบสุข มีหน้าทีประกอบอาชีพเลี้ยงดูครอบครัว และช่วยทำงานที่เป็นต่อประโยชน์ส่วนรวม แต่ในสยามมีศึกสงคราม ชายฉกรรจ์มีหน้าที่รับใช้บ้านเมือง</h5>
        <h5 className="dd"><Spinner type="grow" color="secondary" />(๒) พระสงฆ์ เป็นกลุ่มนักบวช มีหน้าที่สั่งสอนหลักธรรมให้แก่ประชาชน และเป็นศูนย์เผยแผ่พระพุทธศาสนาจากการศึกษาศิลาจารึกหลักที่ 1 ทำให้เราทราบว่า ในสมัยสุโขทัยมีการใช้กฎหมาย เพื่อควบคุมความเป็นระเบียบเรียบร้อยให้เกิดขึ้นในสังคม เช่น เกี่ยวกับการร้องทุกข์ฎีกาเมื่อไม่ได้รับความเป็นธรรมมีข้อความกล่าวถึงว่า เมื่อราษฎรคนใดมีคดีความที่จะถวายฎีกาต่อองค์พระมหากษัตริย์ ก็ให้ไปสั่นกระดิ่งที่แขวนไว้หน้าประตูพระราชวัง พระเจ้าแผ่นดินจะเสด็จมาสอบสวนคดีความและตัดสินด้วยความเป็นธรรมเกี่ยวกับการพิจารณาคดีความ มีข้อความกล่าวว่า เมื่อมีคดีความเกิดขึ้น ให้ทำการสอบสวนว่าใครเป็นฝ่ายผิดใครเป็นฝ่ายถูก แล้วจึงตัดสินอย่างยุติธรรม ห้ามมิให้รับสินบนข้างใดข้างหนึ่ง ดังนั้นความในศิลาจารึกว่า</h5>
        <h5 className="dd2"> …ไพร่ฟ้าลูกเจ้าลูกขุน ผิแลผิดแผกแสกว้างกัน สวนดูแท้แล<br></br>
จึ่งแล่งความแก่เขาด้วยซื่อ บ่เข้าผู้ลักทักผู้ซ้อน<br></br>
เห็นข้าวท่านบ่ใคร่พินเห็นสินท่านบ่ใคร่เดือด...<br></br>
</h5>
        <h5 className="dd2">(ข้อความที่แปล)  …ประชาชน เจ้านาย ขุนนาง ที่ไม่ถูกกัน ก็ให้ไต่สวนด้วยความ ซื่อตรง อย่าเข้าข้างคนผิด อย่าเห็นแก่ทรัพย์สินที่มีคนนำมาติดสินบน…</h5>
       <br></br>
      </Form>
        <Form className="b1"><h5 className="textS">มรดกทางวัฒนธรรมของสุโขทัย</h5>
        <h5 className="dd">สังคมสุโขทัยยึดมั่นในพระพุทธศาสนา ประชาชนจึงได้รับการขัดเกลาจิตใจให้มีความละเอียดอ่อน ทั้งในแง่ของหลักธรรมและศิลปกรรมต่างๆ ทำให้สามารถสร้างสรรค์ศิลปวัฒนธรรมไว้มากมาย ดังต่อไปนี้</h5>
        <h5 className="dd">ด้านศาสนา</h5>
        <h5 className="dd"><Spinner type="grow" color="warning" />พระมหากษัตริย์ในสมัยสุโขทัยทรงมีศรัทธาต่อพระพุทธศาสนาทรงนำราษฎรปฏิบัติธรรมและทำกิจกรรมทางศาสนา โดยเฉพาะพระมาหาธรรมราชาที่ 1 (ลิไทย) พระองค์ทรงออกผนวกและทรงนิพนธ์งานทางศาสนา เช่น หนังสือไตรภูมิพระร่วง เป็นต้น นอกจากนั้นยังมีประเพณีการสร้างวัดขึ้นในเขตพระราชวัง เพื่อใช้สำหรับประกอบพระราชพิธีทางศาสนาและพระราชพิธีอื่นๆ ที่สืบทอดมาจนถึงปัจจุบัน</h5>
        <h5 className="dd">ด้านศิลปกรรม</h5>
        <h5 className="dd"><Spinner type="grow" color="secondary" />(๑) สถาปัตยกรรม สิ่งก่อสร้างสมัยสุโขทัยมีความงดงามและเป็นแบบอย่างของสุโขทัยโดยเฉพาะ ดังจะเห็นได้จากการก่อสร้างเจดีย์ในสมัยสุโขทัยตอนต้น  ที่นิยมก่อสร้างเจดีย์ทรงกลมแบบลังกา  ซึ่งได้รับอิทธิพลมาจากพระพุทธศาสนาลัทธิลังกาวงศ์ต่อมาในสมัยสุโขทัยตอนปลายการก่อสร้างเจดีย์จะมีลักษณะสวยงามยิ่งขึ้น   เป็นรูปแบบสุโขทัยแท้  คือเจดีย์ทรงพุ่มข้าวบิณฑ์  หรือส่งดอกมะตูม นอกจากนี้  สมัยสุโขทัยจะนิยมสร้างวิหารใหญ่กว่าโบสถ์มีกำแพงทึบ  และเจาะเป็นช่องเล็กๆ  คล้ายกับหน้าต่างเพื่อให้แสงลอดผ่านเข้าข้างในได้ ซึ่งเป็นลักษณะเฉพาะของการสร้างวิหารในสมัยนั้น  จะนิยมสร้างไว้ด้านหน้าของเจดีย์  เช่นวิหารหลวงที่เมืองสุโขทัย  วิหารหลวงที่วัดมหาธาตุ  เป็นต้น</h5>
        <h5 className="dd"><Spinner type="grow" color="secondary" />(๒) ประติมากรรม  การก่อสร้างพระพุทธรูป  สมัยสุโขทัยนิยมหล่อพระพุทธรูปจากโลหะสำริด  ซึ่งเป็นศิลปะแบบสุโขทัยแท้พระพุทธรูปสมัยสุโขทัยที่สวยงามที่สุดของชาติไทย ได้แก่พระพุทธชินราช พระศรีศากยมุนี เป็นต้น</h5>
        <h5 className="dd"><Spinner type="grow" color="secondary" />(๓) งานจิตรกรรมงาน จิตรกรรมสมัยสุโขทัยมีทั้งภาพลายเส้นและภาพสีฝุ่น เช่น จิตรกรรมงานเขียนลายเส้นเรื่องชาดกสลักบนหินชนวนที่ผนังอุโมงค์ในวัดศรีชุม จังหวัดสุโขทัย และภาพจิตรกรรมฝาผนัง  ใช้สีแดง ดำ ขาว เป็นหลัก เช่น ภาพเขียนที่วัดเจดีย์เจ็ดแถวเป็นเมืองศรีสัชนาลัย จังหวัดสุโขทัยเป็นต้</h5>
        </Form>
        <Form className="b1"><h5 className="textS">ด้านภาษาและวรรณกรรม</h5>
        <h5 className="dd"><Spinner type="grow" color="warning" />มรดกทางวัฒนธรรมของสุโขทัยที่สำคัญ คือ ตัวอักษรไทยและวรรณกรรม  ตัวอักษรไทย เรียกว่าลายสือไทย  พ่อขุนรามคำแหงทรงประดิษฐ์ขึ้นเมื่อปี พ.ศ. 1826 ตัวอักษรไทยที่พ่อขุนรามคำแหงทรงประดิษฐ์ขึ้นนั้นได้ดัดแปลงมาจากอักษรขอมและอักษรมอญมีลักษณะการจัดวางรูปสระให้เรียงอยู่บนบรรทัดเดียวกันกับพยัญชนะการประดิษฐ์อักษรไทยทำให้เกิดวรรณกรรมที่สำคัญ ได้แก่ ศิลาจารึกพ่อขุนรามคำแหง หรือศิลาจารึกหลักที่ 1 นอกจากนี้ยังมีวรรณคดีที่สำคัญ ได้แก่ ไตรภูมิพระร่วง (เตภูมิกถา)</h5>
        </Form>
        <Form className="b1"><h5 className="textS">ด้านขนบธรรมเนียมประเพณี</h5>
        <h5 className="dd"><Spinner type="grow" color="warning" />ขนบธรรมเนียมประเพณีต่างๆ  เป็นสิ่งที่สะท้อนให้เห็นถึงความเป็นอยู่ของคนไทยในสังคมขนบธรรมเนียมและประเพณีในสมัยสุโขทัยจะเกี่ยวข้องกับพระพุทธศาสนาเป็นส่วนใหญ่  เนื่องจากคนไทยในกรุงสุโขทัยนับถือพระพุทธศาสนากันอย่างกว้างขวาง  ทำให้พระพุทธศาสนาเข้ามามีอิทธิพลต่อวิถีชีวิตของผู้คนในสุโขทัยเป็นอย่างมาก  เช่น  ประเพณีการสร้างวัดในเขตพระราชวัง ประเพณีทำบุญเข้าพรรษาและออกพรรษา  รักษาศีลฟังเทศน์ในวันสำคัญทางพระพุทธศาสนา เป็นต้น</h5>
        <h5 className="dd"><Spinner type="grow" color="warning" />ขนบธรรมเนียมประเพณีของสุโขทัย  เป็นมรดกตกทอดมาจนถึงปัจจุบัน  ได้แก่  การละเล่นพื้นรื่นเริง  ประเพณีการเผาเทียนเล่นไฟ และพระราชพิธีต่างๆ  เช่น  พระราชพิธีลอยพระประทีป  เป็นต้น </h5>
        </Form>
        
            <img className="photo4"
              width="700"
              height="700"
          onClick={() => this.setState({ isOpen: true })}
          src={Game}
          alt="QRcode"
          
        ></img>
        {isOpen && (
          <Lightbox
            mainSrc={Game}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
        <h5 className="dd" align='center'></h5>
 

        <p h5 align='center'><Button href='/study' outline color="warning" >ย้อนกลับ</Button>{' '}</p>
          <p h5 align='center'><Button href='/study' outline color="primary" >บทถัดไป</Button>{' '}</p>
        
        </Form>
        </Container>

        <div className="footer text-footer">
          <p>Surasak   Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>           
          <NavLink href="https://surasak783023869.wordpress.com/">ช่องทางการติดต่อ</NavLink>
        </div>

      </div>
    )
  }
}

export default CreateStudy7